/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Not_ConfiguredInputs */

const en_error_allocation_not_configured = /** @type {(inputs: Error_Allocation_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The allocation is not set up: its thresholds are missing.`)
};

/**
* | output |
* | --- |
* | "The allocation is not set up: its thresholds are missing." |
*
* @param {Error_Allocation_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_not_configured = /** @type {((inputs?: Error_Allocation_Not_ConfiguredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Not_ConfiguredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_not_configured(inputs)
});